// Angular
import { ElementRef, Injectable, OnDestroy, OnInit } from '@angular/core';
import { animate, AnimationBuilder, style } from '@angular/animations';

// Libraries
import { BehaviorSubject } from 'rxjs';

// Models
import { AppCleanup } from '../../../models';

@Injectable()
export class SplashScreenService extends AppCleanup implements OnInit, OnDestroy {
	// Private properties
	private el: ElementRef;
	private stopped: boolean;
	initialized: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

	/**
	 * Service constctutor
	 *
	 * @param animationBuilder: AnimationBuilder
	 */
	constructor(private animationBuilder: AnimationBuilder) {
		super();
	}

	ngOnDestroy() {
		super.ngOnDestroy();
		if (this.initialized) {
			this.initialized.complete();
		}
	}

	/**
	 * Init
	 *
	 * @param element: ElementRef
	 */
	init(element: ElementRef) {
		this.el = element;
		this.initialized.next(true);
	}

	hide() {
		if (this.stopped) {
			return;
		}

		const player = this.animationBuilder
			.build([style({ opacity: '1' }), animate(800, style({ opacity: '0' }))])
			.create(this.el.nativeElement);

		player.onDone(() => {
			if (typeof this.el.nativeElement.remove === 'function') {
				this.el.nativeElement.remove();
			} else {
				this.el.nativeElement.style.display = 'none';
			}
			this.stopped = true;
		});

		setTimeout(() => player.play(), 300);
		this.initialized.next(false);
	}
}
